import Tabs, { TabPane } from 'rc-tabs';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Pagination, Navigation } from 'swiper';
import { DepositHeader } from '..';
import { useState, useEffect } from 'react';
import Modal from './Modal';

SwiperCore.use([Pagination, Navigation])

  // 如果Mockup上有無標題文字垂直置中的狀況，className可以使用contentWithoutTitle
  // 目前Mockup更新為都有標題
const channelData = [
  {
      step: 'ขั้นตอนที่ 1',
      content: <p className='contentWithTitle' data-CN="選擇渠道&幣別">
          เลือกช่องทางการ ฝากคริปโทแบบด่วน และเลือก สกุลเงินที่คุณต้องการ จากนั้น คลิก ถัดไป
      </p>,
      stepCN: '步骤1',
  },
  {
      step: 'ขั้นตอนที่ 2',
      content: <p className='contentWithTitle' data-CN="点击“确认”，进入支付页面。">
          คลิก ยืนยัน เพื่อเข้าสู่หน้าชำระเงิน
      </p>,
      stepCN: '步骤2',
  },
  {
      step: 'ขั้นตอนที่ 3',
      content: <p className='contentWithTitle' data-CN="使用電子支付掃描第二步驟的QR code">
          ใช้กระเป๋าเงินดิจิตอลของคุณสแกน QR หรือคัดลอก
          ที่อยู่กระเป๋าเงินเพื่อทำการฝากเงินในขั้นตอนที่ 2
          หมายเหตุ:  ที่อยู่บัญชีนี้เป็นที่อยู่เฉพาะของคุณ
          สามารถใช้ได้หลายครั้ง
      </p>,
      stepCN: '步骤3',
  },
  {
      step: 'ขั้นตอนที่ 4',
      content: <p className='contentWithTitle' data-CN="您的交易被确认后。 余额将转入您的游戏钱包。 在“交易记录”中查看交易记录">
          สามารถคคลิกดูประวัติการทำธุรกรรมได้ที่ “ประวัติการทำรายการ” หลังจากธุรกรรมของคุณได้รับการ
          ยืนยันเรียบร้อยแล้ว ยอดเงินจะถูกโอนเข้ากระเป๋าเงินเกมของคุณ
      </p>,
      stepCN: '步骤4',
  },
  {
      step: 'ขั้นตอนที่ 5',
      content: <p className='contentWithTitle' data-CN="有關加密貨幣信息，您可以在這些網站上查看">
          สำหรับข้อมูลเพิ่มเติมเกี่ยวกับคริปโทเคอร์เรนซี่คุณสามารถตรวจสอบได้ที่เว็บไซต์เหล่านี้
      </p>,
  }
]

const invoiceData = [
  {
      step: 'ขั้นตอนที่ 1',
      content: <p className='contentWithTitle' data-CN="選擇虛擬幣存款方式並輸入存款金額">
        เลือกช่องทาง ฝากคริปโทแบบธรรมดา และเลือก สกุลเงินที่คุณต้องการ จากนั้น<br/> 
         ระบุจำนวนเงินและคลิก “ถัดไป”
      </p>,
      stepCN: '步骤1',
  },
  {
      step: 'ขั้นตอนที่ 2',
      content: <p className='contentWithTitle' data-CN="複製錢包地址或使用電子錢包掃碼">
        คัดลอกที่อยู่กระเป๋าเงิน หรือใช้กระเป๋าเงินดิจิตอล สแกน QR เพื่อฝากเงิน
      </p>,
      stepCN: '步骤2',
  },
  {
      step: 'ขั้นตอนที่ 3',
      content: <p className='contentWithTitle' data-CN="您的交易被确认后。 余额将转入您的游戏钱包。 在“交易记录”中查看交易记录">
        สามารถคคลิกดูประวัติการทำธุรกรรมได้ที่ “ประวัติการทำรายการ” หลังจากธุรกรรมของคุณได้รับการ
        ยืนยันเรียบร้อยแล้ว ยอดเงินจะถูกโอนเข้ากระเป๋าเงินเกมของคุณ
      </p>,
      stepCN: '步骤3',
  },
  {
      step: 'ขั้นตอนที่ 4',
      content: <p className='contentWithTitle' data-CN="有關加密貨幣信息，您可以在這些網站上查看">
        สำหรับข้อมูลเพิ่มเติมเกี่ยวกับคริปโทเคอร์เรนซี่คุณสามารถตรวจสอบได้ที่เว็บไซต์เหล่านี้
      </p>,
      stepCN: '步骤4',
  }
]

function CTCTutorialModal(props){
  const {visible, onClose, method} = props;
  const [selectedKey, setSelectedKey] = useState('1')
  const [ channelIsBeginning, setChannelIsBeginning ] = useState(true);
  const [ channelIsEnd, setChannelIsEnd ] = useState(false);
  const [ invoiceIsBeginning, setInvoiceIsBeginning ] = useState(true);
  const [ invoiceIsEnd, setInvoiceIsEnd ] = useState(false);

  function tabChange(key){
    setSelectedKey(key)
    setChannelIsBeginning(true);
    setChannelIsEnd(false);
    setInvoiceIsBeginning(true);
    setInvoiceIsEnd(false);
  }
  useEffect(()=>{
    if(visible){
      if(method==="INVOICE"){
        setSelectedKey('2')
      }else{
        setSelectedKey('1')
      }
    }
  }, [visible])
  const closedModal = () => {
    onClose();
    setChannelIsBeginning(true);
    setChannelIsEnd(false);
    setInvoiceIsBeginning(true);
    setInvoiceIsEnd(false);
};
  return (
    <Modal
      className='tutorialModal'
      visible={visible}
      fullscreen={false}
      title={<DepositHeader title={'ขั้นตอนการฝากเงิน'} closeBtn={closedModal} visibleBtn={false} />}
      onOk={closedModal}
      onlyOkBtn={true}
      okText={"ปิด"}
    >
      <Tabs activeKey={selectedKey} onChange={tabChange} className='usdtDepositLesson'>
          <TabPane tab="ฝากคริปโทแบบด่วน" key="1">
            {/* 為了讓切換時回到第一張 */}
            {selectedKey === '1' && (
              <Swiper
                  slidesPerView={1}
                  spaceBetween={30}
                  loop={true}
                  pagination={{
                      clickable: true,
                  }}
                  navigation={true}
                  className={`${channelIsBeginning ? "hide-prev" : ""}${channelIsEnd ? "hide-next" : ""}`}
                  onSlideChange={(e) => {
                    setChannelIsBeginning(e.isBeginning);
                    setChannelIsEnd(e.isEnd);
                  }}
              >
                  {channelData.map((item, index) => {
                      return (
                          <SwiperSlide key={index + 'step'}>
                              <div className="tutorialCard">
                                  <div className={`tutorial_img tutorialPic_Deposit_Channel_${index+1}`}/>
                                  {item?.step && <h3 data-CN={item.stepCN}>{item.step}</h3>}
                                  {item.content}
                              </div>
                          </SwiperSlide>
                      );
                  })}
              </Swiper>
            )}
          </TabPane>
          <TabPane tab="ฝากคริปโทแบบธรรมดา" key="2">
            {selectedKey === '2' && (
            <Swiper
                slidesPerView={1}
                spaceBetween={30}
                loop={true}
                pagination={{
                    clickable: true,
                }}
                navigation={true}
                className={`${invoiceIsBeginning ? "hide-prev" : ""}${invoiceIsEnd ? "hide-next" : ""}`}
                onSlideChange={(e) => {
                  setInvoiceIsBeginning(e.isBeginning);
                  setInvoiceIsEnd(e.isEnd);
                }}
            >
                {invoiceData.map((item, index) => {
                    return (
                        <SwiperSlide key={index + 'step'}>
                            <div className="tutorialCard">
                                <div className={`tutorial_img tutorialPic_Deposit_Invoice_${index+1}`}/>
                                {item?.step && <h3 data-CN={item.stepCN}>{item.step}</h3>}
                                {item.content}
                            </div>
                        </SwiperSlide>
                    );
                })}
            </Swiper>
            )}
          </TabPane>
      </Tabs>
    </Modal>
  )
}

export default CTCTutorialModal
